export default __webpack_public_path__ + "static/media/cctvcamera1.d92426b1.jpeg";